export const logMessage = (message: string) => {
  console.log(`${new Date().toISOString()} - ${message}`);
};
